(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-sticky-nav"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {
  // Toggle dropdown visibility
  $(".alpha_nav_toggle").on("click", function () {
    $(this).toggleClass("active");
    $(".av-float-nav__block").toggleClass("show");
  });

  // Update .alpha_nav_toggle h6 text and close the dropdown on menu item click
  $(".inner-page-menu-items li a").on("click", function () {
    const selectedText = $(this).text();
    $(".alpha_nav_toggle h6").text(selectedText);
    $(".av-float-nav__block").removeClass("show");
    $(".alpha_nav_toggle").removeClass("active");
  });

  // Scroll-based section highlighting and toggle text update
  var $links = $(".av-float-nav__nav-link");
  var sections = $links.map(function () {
    return $($(this).attr("href"));
  });

  function updateActiveClass() {
    var scrollPosition = $(window).scrollTop();
    var headerHeight = $(".page-sticky-nav").outerHeight() || 60;
    var activeSection = null;

    sections.each(function () {
      var $section = $(this);
      var offset = $section.offset();
      if (!offset) return;

      var sectionTop = offset.top - headerHeight;
      var sectionBottom = sectionTop + $section.outerHeight();

      if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
        activeSection = this;
        return false;
      }
    });

    $links.parent('.menu-item').removeClass("active");
    if (activeSection) {
      var activeLink = $links.filter('[href="#' + $(activeSection).attr("id") + '"]');
      activeLink.parent('.menu-item').addClass("active");
      $(".alpha_nav_toggle h6").text(activeLink.text());
    }
  }

  $(window).on("scroll", updateActiveClass);
  updateActiveClass();

  // Handle regular links - Check current page URL and mark as active
  var currentPath = window.location.pathname;
  console.log("Current Path:", currentPath);
  
  $(".av-float-nav__nav-link").each(function() {
    var href = $(this).attr("href");
    console.log("Checking link:", href);
    
    // Check if this link matches the current page
    if (href && !href.startsWith("#")) {
      var linkPath = href;
      
      // If the current page matches this link, mark it active
      if (currentPath === linkPath || currentPath.includes(linkPath)) {
        console.log("MATCH FOUND! Adding active to:", href);
        $(this).parent('.menu-item').addClass("active");
        $(".alpha_nav_toggle h6").text($(this).text());
      }
      
      // Handle clicks on regular links
      $(this).on("click", function(e) {
        console.log("Link clicked:", $(this).attr("href"));
        var selectedText = $(this).text();
        $(".alpha_nav_toggle h6").text(selectedText);
        $(".av-float-nav__nav-link").parent('.menu-item').removeClass("active");
        $(this).parent('.menu-item').addClass("active");
        $(".av-float-nav__block").removeClass("show");
        $(".alpha_nav_toggle").removeClass("active");
      });
    }
  });

});

  } catch(e) { console.error(e); }
})();
})();
